var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-e2e-class":"styleguide-layout-tabs-tab"}},[(_vm.isEditing)?_c('sc-text',{attrs:{"tag":"h5","field":_vm.fields.title}}):_vm._e(),_c('sc-rich-text',{attrs:{"field":_vm.fields.content}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }